import React from 'react';
import { Link } from 'react-router-dom';
import Flagship from '../components/Flagship';
import { StatusBadge } from '../components/Ledger';
import { alsoBuilding, flagships, moreProjects } from '../data/projects';
import usePageMeta from '../hooks/usePageMeta';
import '../styles/Projects.css';

const Projects = () => {
  usePageMeta('Work', 'A showcase of my work in automation, testing, and AI development');

  return (
    <div className="work">
      <header className="page-header container">
        <h1>Work</h1>
      </header>

      <div className="container">
        {flagships.map((study, i) => (
          <Flagship key={study.slug} study={study} reversed={i % 2 === 1} condensed />
        ))}

        {alsoBuilding.map((study) => (
          <section key={study.slug} className="work-row" aria-labelledby={`work-${study.slug}`}>
            <span className="label label-accent">Also building</span>
            <div className="work-row-body">
              <div className="work-row-head">
                <h2 id={`work-${study.slug}`} className="work-row-title">
                  {study.alsoBuilding.title}
                </h2>
                <StatusBadge status={study.alsoBuilding.badge} />
              </div>
              <p>{study.alsoBuilding.line}</p>
              <Link to={`/projects/${study.slug}`} className="text-link">
                Read the case study <span className="arrow" aria-hidden="true">→</span>
              </Link>
            </div>
          </section>
        ))}

        <section className="work-row" aria-labelledby="more-projects">
          <h2 id="more-projects" className="label label-accent">
            More projects
          </h2>
          <ul className="more-list">
            {moreProjects.map((project) => {
              const link = project.links[0];
              return (
                <li key={project.title}>
                  <h3>{project.title}</h3>
                  <p>{project.summary}</p>
                  <a href={link.href} target="_blank" rel="noopener noreferrer" className="text-link">
                    {link.label} <span className="arrow" aria-hidden="true">→</span>
                  </a>
                </li>
              );
            })}
          </ul>
        </section>
      </div>
    </div>
  );
};

export default Projects;
